<div class="mart-order-details-title">Transaction record</div>

<p-table [value]="parent.order.Transactions"
         [resizableColumns]="true"
         [columnResizeMode]="'expand'"
         [autoLayout]="true"
         [styleClass]="'p-datatable-striped'"
         [scrollable]="true"
         [scrollHeight]="'600px'">
    <ng-template pTemplate="header">
        <tr>
            <th pResizableColumn>TRXN</th>
            <th pResizableColumn>MID</th>
            <th pResizableColumn>Partner TRXN ID</th>
            <th pResizableColumn>Xpress Status</th>
            <th pResizableColumn>Partner Status</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-item>
        <tr>
            <td class="ui-resizable-column">{{item.Id}}</td>
            <td class="ui-resizable-column">{{parent.order.PaymentMethod}}</td>
            <td class="ui-resizable-column"></td>
            <td class="ui-resizable-column">{{item.Status}}</td>
            <td class="ui-resizable-column"></td>
        </tr>
    </ng-template>
</p-table>
